/*
 *
 * GenericToast
 *
 * @version 1.0.0
 * @author tfrazzet
 * @since 18-Sep-2024
*/

import { connect } from 'react-redux'
import GenericToast from './GenericToast'
import { nullSafe } from 'Utility/globalMethods'
import { bindActionCreators } from 'redux'
import { doHideToast } from 'Store/actions/toast'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doHideToast }, dispatch)
})

const mapStateToProps = state => ({
  icon: nullSafe(() => state.toast.toastInfo.icon, false),
  label: nullSafe(() => state.toast.toastInfo.label, ''),
  severity: nullSafe(() => state.toast.toastInfo.severity, ''),
  duration: nullSafe(() => state.toast.toastInfo.duration, 15000),
  directionSlide: nullSafe(() => state.toast.toastInfo.directionSlide, 'down')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(GenericToast)
